import "bootstrap/dist/css/bootstrap.min.css";
import BaseModal from "../../BaseModal";

function InscripcionEquipo() {
  return (
    <div>
      <BaseModal modalType="ComingSoon"></BaseModal>
    </div>
  );
}

export default InscripcionEquipo;
